import { toast } from "react-toastify";
import { EAlgoApiObjectType } from "~/interfaces";


export const GenericToastError = (message: string, id: string) => {
    toast(message, {type: "error", hideProgressBar: true, toastId: id, className: "toast-error"});
}

export const ToastError = (type: EAlgoApiObjectType) => {
    const dataType = EAlgoApiObjectType[type as keyof typeof EAlgoApiObjectType].toString().replaceAll("-", " ");
    const pluralType = dataTypeToPlural(type, dataType);
    
    toast(`There was an error loading ${pluralType}`, {type: "error", hideProgressBar: true, toastId: dataType, className: "toast-error"});
}

const dataTypeToPlural = (
    type: EAlgoApiObjectType, dataType: string
) => {

    switch(type){
        case EAlgoApiObjectType["aldot-message"]:
            return "ALDOT messages";
        case EAlgoApiObjectType["alea-alert"]:
            return "ALEA alerts";
        case EAlgoApiObjectType["service-assistance-patrol"]:
            return "ASAP locations";
        case EAlgoApiObjectType.city:
            return "cities";
        case EAlgoApiObjectType.county:
            return "counties";
        case EAlgoApiObjectType.crash:
            return "crashes";
        case EAlgoApiObjectType["state-facility"]:
            return "state facilities";
        case EAlgoApiObjectType.ferry:
            return "ferries";
        case EAlgoApiObjectType.other511:
            return "other state 511 systems";
        case EAlgoApiObjectType.roadwork:
            return "roadwork events";
        default:
            return `${dataType}s`;
    }
}